import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'arabicNumbers'
})
export class ArabicNumbersPipe implements PipeTransform {

  transform(n: number,allowDecimal:boolean=false): string {
    if (n === null || n === undefined) {
      return '';
    }
    return new Intl.NumberFormat('ar-SA',{useGrouping: false,minimumFractionDigits: allowDecimal?2:0,
      maximumFractionDigits: allowDecimal?2:0, }).format(n);
  }

}
